import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'humanize',
    standalone: false
})
export class HumanizePipe implements PipeTransform {
  transform(input: string): string {
    const result = input.replace( /([A-Z])/g, ' $1' );
    return result.charAt(0).toUpperCase() + result.slice(1);
  }
}
